import axios from '@/api/config';
const live = {
  addGoodsItemBatch(data,params) {
    return axios.post(`${process.env.BASE_URL}/goodsItem/addGoodsItemBatch`, data,{ params });
  },
  
  updateGoodsItem(data){
    return axios.put(`${process.env.BASE_URL}//goodsItem/updateGoodsItem`, data);
  }
}

export default live;



// WEBPACK FOOTER //
// ./src/api/live.js